import { Link } from 'react-router-dom'

const Logo = () => {
  return (
        <>
        <Link to="/" style={{ color: 'white', textDecoration: 'none', fontSize: '20px' }}>
            MCQ Hub
        </Link>
        </>
  )
}

export default Logo
